/**
 * WEB-CORE-06 (review 7): the FileUpload ids whose schedule call is on its retry ladder RIGHT NOW
 * (`FileProcessService._scheduleLadderLoop`), whatever the `clientQueuedState` flag says. The card's "never started"
 * verdict reads it: a job whose schedule is still being retried (a `service_busy` ladder honouring Retry-After, up to
 * 5 min) HAS started -- telling the user to "Start it again" there scheduled the job twice. The coordinator tracks the
 * same fact only while it is enabled; this set is the flag-independent one.
 */
const inFlight = new Set<string>();

export const scheduleInFlight = {
    add(id: string | null | undefined): void { if (id) inFlight.add(id); },
    delete(id: string | null | undefined): void { if (id) inFlight.delete(id); },
    has(id: string | null | undefined): boolean { return !!id && inFlight.has(id); },
    /** Specs only. */
    clear(): void { inFlight.clear(); },
};
